module.exports = __webpack_public_path__ + "img/adult-discussion.38cb2160.png";